/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthenticatedWorkspaceRouteImport } from './routes/_authenticated/_workspace'
import { Route as AuthenticatedAppRouteImport } from './routes/_authenticated/_app'
import { Route as AuthSessionExpiredRouteImport } from './routes/_auth/session-expired'
import { Route as AuthLoginCompleteRouteImport } from './routes/_auth/login-complete'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthInvitationRouteImport } from './routes/_auth/invitation'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthAuthActionRouteImport } from './routes/_auth/auth-action'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/_app/index'
import { Route as AuthenticatedAppTransfersRouteImport } from './routes/_authenticated/_app/transfers'
import { Route as AuthMcpAuthorizeRouteImport } from './routes/_auth/mcp.authorize'
import { Route as AuthenticatedAppUserManagementRouteRouteImport } from './routes/_authenticated/_app/user-management/route'
import { Route as AuthenticatedAppSupervisorRouteRouteImport } from './routes/_authenticated/_app/supervisor/route'
import { Route as AuthenticatedAppRawFootageRouteRouteImport } from './routes/_authenticated/_app/raw-footage/route'
import { Route as AuthenticatedAppProfileRouteRouteImport } from './routes/_authenticated/_app/profile/route'
import { Route as AuthenticatedAppMetadataRouteRouteImport } from './routes/_authenticated/_app/metadata/route'
import { Route as AuthenticatedAppFieldRouteRouteImport } from './routes/_authenticated/_app/field/route'
import { Route as AuthenticatedAppDevicesRouteRouteImport } from './routes/_authenticated/_app/devices/route'
import { Route as AuthenticatedAppDeliveryRouteRouteImport } from './routes/_authenticated/_app/delivery/route'
import { Route as AuthenticatedAppCalibrationRouteRouteImport } from './routes/_authenticated/_app/calibration/route'
import { Route as AuthenticatedAppSupervisorIndexRouteImport } from './routes/_authenticated/_app/supervisor/index'
import { Route as AuthenticatedAppRawFootageIndexRouteImport } from './routes/_authenticated/_app/raw-footage/index'
import { Route as AuthenticatedAppFieldIndexRouteImport } from './routes/_authenticated/_app/field/index'
import { Route as AuthenticatedAppDeliveryIndexRouteImport } from './routes/_authenticated/_app/delivery/index'
import { Route as AuthenticatedWorkspaceDevicesDeviceIdRouteImport } from './routes/_authenticated/_workspace/devices/$deviceId'
import { Route as AuthenticatedWorkspaceAssetsAssetIdRouteImport } from './routes/_authenticated/_workspace/assets/$assetId'
import { Route as AuthenticatedAppUserManagementInvitationsRouteImport } from './routes/_authenticated/_app/user-management/invitations'
import { Route as AuthenticatedAppUserManagementAccountRouteImport } from './routes/_authenticated/_app/user-management/account'
import { Route as AuthenticatedAppSupervisorSegmentsRouteImport } from './routes/_authenticated/_app/supervisor/segments'
import { Route as AuthenticatedAppSupervisorAssetsRouteImport } from './routes/_authenticated/_app/supervisor/assets'
import { Route as AuthenticatedAppProfileAccountRouteImport } from './routes/_authenticated/_app/profile/account'
import { Route as AuthenticatedAppMetadataCollectionRouteImport } from './routes/_authenticated/_app/metadata/$collection'
import { Route as AuthenticatedAppFieldTodayRouteImport } from './routes/_authenticated/_app/field/today'
import { Route as AuthenticatedAppFieldHistoryRouteImport } from './routes/_authenticated/_app/field/history'
import { Route as AuthenticatedAppDevicesListRouteImport } from './routes/_authenticated/_app/devices/list'
import { Route as AuthenticatedAppDevicesInactiveRouteImport } from './routes/_authenticated/_app/devices/inactive'
import { Route as AuthenticatedAppDevicesInTransitRouteImport } from './routes/_authenticated/_app/devices/in-transit'
import { Route as AuthenticatedAppDeliveryDeliveryIdRouteImport } from './routes/_authenticated/_app/delivery/$deliveryId'
import { Route as AuthenticatedAppCalibrationWorkstationsRouteImport } from './routes/_authenticated/_app/calibration/workstations'
import { Route as AuthenticatedAppAdminOrganizationsRouteImport } from './routes/_authenticated/_app/admin/organizations'
import { Route as AuthenticatedAppUserManagementRoleRouteRouteImport } from './routes/_authenticated/_app/user-management/role/route'
import { Route as AuthenticatedAppSupervisorTeamRouteRouteImport } from './routes/_authenticated/_app/supervisor/team/route'
import { Route as AuthenticatedAppSupervisorTaskAssignmentRouteRouteImport } from './routes/_authenticated/_app/supervisor/task-assignment/route'
import { Route as AuthenticatedAppCalibrationDevicesRouteRouteImport } from './routes/_authenticated/_app/calibration/devices/route'
import { Route as AuthenticatedAppUserManagementRoleIndexRouteImport } from './routes/_authenticated/_app/user-management/role/index'
import { Route as AuthenticatedAppSupervisorTeamIndexRouteImport } from './routes/_authenticated/_app/supervisor/team/index'
import { Route as AuthenticatedAppSupervisorTaskAssignmentIndexRouteImport } from './routes/_authenticated/_app/supervisor/task-assignment/index'
import { Route as AuthenticatedAppDevicesTypesIndexRouteImport } from './routes/_authenticated/_app/devices/types/index'
import { Route as AuthenticatedAppCalibrationDevicesIndexRouteImport } from './routes/_authenticated/_app/calibration/devices/index'
import { Route as AuthenticatedWorkspaceUserManagementAccountUidRouteImport } from './routes/_authenticated/_workspace/user-management/account/$uid'
import { Route as AuthenticatedWorkspaceFieldVisitsVisitIdRouteImport } from './routes/_authenticated/_workspace/field/visits/$visitId'
import { Route as AuthenticatedAppUserManagementRolePermissionSetIdRouteImport } from './routes/_authenticated/_app/user-management/role/$permissionSetId'
import { Route as AuthenticatedAppSupervisorTeamFieldActivityRouteImport } from './routes/_authenticated/_app/supervisor/team/field-activity'
import { Route as AuthenticatedAppSupervisorTeamCamerasRouteImport } from './routes/_authenticated/_app/supervisor/team/cameras'
import { Route as AuthenticatedAppSupervisorTaskAssignmentNewRouteImport } from './routes/_authenticated/_app/supervisor/task-assignment/new'
import { Route as AuthenticatedAppSupervisorTaskAssignmentRequestIdRouteImport } from './routes/_authenticated/_app/supervisor/task-assignment/$requestId'
import { Route as AuthenticatedAppRawFootageUploadsSessionIdRouteImport } from './routes/_authenticated/_app/raw-footage/uploads/$sessionId'
import { Route as AuthenticatedAppCalibrationDevicesDeviceIdRouteImport } from './routes/_authenticated/_app/calibration/devices/$deviceId'
import { Route as AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRouteImport } from './routes/_authenticated/_app/raw-footage/organizations/$organizationId/index'
import { Route as AuthenticatedAppCalibrationDevicesDeviceIdIndexRouteImport } from './routes/_authenticated/_app/calibration/devices/$deviceId/index'
import { Route as AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRouteImport } from './routes/_authenticated/_app/relocations/$organizationId/$projectId/$footageKey'
import { Route as AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRouteImport } from './routes/_authenticated/_app/raw-footage/mcap-segments/$assetId/$segmentId'
import { Route as AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRouteImport } from './routes/_authenticated/_workspace/calibration/devices/$deviceId/sessions/$sessionId'
import { Route as AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRouteImport } from './routes/_authenticated/_app/raw-footage/organizations/$organizationId/projects/$projectId'

const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkspaceRoute = AuthenticatedWorkspaceRouteImport.update({
  id: '/_workspace',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppRoute = AuthenticatedAppRouteImport.update({
  id: '/_app',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthSessionExpiredRoute = AuthSessionExpiredRouteImport.update({
  id: '/session-expired',
  path: '/session-expired',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginCompleteRoute = AuthLoginCompleteRouteImport.update({
  id: '/login-complete',
  path: '/login-complete',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvitationRoute = AuthInvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthActionRoute = AuthAuthActionRouteImport.update({
  id: '/auth-action',
  path: '/auth-action',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAppRoute,
} as any)
const AuthenticatedAppTransfersRoute =
  AuthenticatedAppTransfersRouteImport.update({
    id: '/transfers',
    path: '/transfers',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthMcpAuthorizeRoute = AuthMcpAuthorizeRouteImport.update({
  id: '/mcp/authorize',
  path: '/mcp/authorize',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedAppUserManagementRouteRoute =
  AuthenticatedAppUserManagementRouteRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppSupervisorRouteRoute =
  AuthenticatedAppSupervisorRouteRouteImport.update({
    id: '/supervisor',
    path: '/supervisor',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppRawFootageRouteRoute =
  AuthenticatedAppRawFootageRouteRouteImport.update({
    id: '/raw-footage',
    path: '/raw-footage',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppProfileRouteRoute =
  AuthenticatedAppProfileRouteRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppMetadataRouteRoute =
  AuthenticatedAppMetadataRouteRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppFieldRouteRoute =
  AuthenticatedAppFieldRouteRouteImport.update({
    id: '/field',
    path: '/field',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppDevicesRouteRoute =
  AuthenticatedAppDevicesRouteRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppDeliveryRouteRoute =
  AuthenticatedAppDeliveryRouteRouteImport.update({
    id: '/delivery',
    path: '/delivery',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppCalibrationRouteRoute =
  AuthenticatedAppCalibrationRouteRouteImport.update({
    id: '/calibration',
    path: '/calibration',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppSupervisorIndexRoute =
  AuthenticatedAppSupervisorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppSupervisorRouteRoute,
  } as any)
const AuthenticatedAppRawFootageIndexRoute =
  AuthenticatedAppRawFootageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppRawFootageRouteRoute,
  } as any)
const AuthenticatedAppFieldIndexRoute =
  AuthenticatedAppFieldIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppFieldRouteRoute,
  } as any)
const AuthenticatedAppDeliveryIndexRoute =
  AuthenticatedAppDeliveryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppDeliveryRouteRoute,
  } as any)
const AuthenticatedWorkspaceDevicesDeviceIdRoute =
  AuthenticatedWorkspaceDevicesDeviceIdRouteImport.update({
    id: '/devices/$deviceId',
    path: '/devices/$deviceId',
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any)
const AuthenticatedWorkspaceAssetsAssetIdRoute =
  AuthenticatedWorkspaceAssetsAssetIdRouteImport.update({
    id: '/assets/$assetId',
    path: '/assets/$assetId',
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any)
const AuthenticatedAppUserManagementInvitationsRoute =
  AuthenticatedAppUserManagementInvitationsRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => AuthenticatedAppUserManagementRouteRoute,
  } as any)
const AuthenticatedAppUserManagementAccountRoute =
  AuthenticatedAppUserManagementAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedAppUserManagementRouteRoute,
  } as any)
const AuthenticatedAppSupervisorSegmentsRoute =
  AuthenticatedAppSupervisorSegmentsRouteImport.update({
    id: '/segments',
    path: '/segments',
    getParentRoute: () => AuthenticatedAppSupervisorRouteRoute,
  } as any)
const AuthenticatedAppSupervisorAssetsRoute =
  AuthenticatedAppSupervisorAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AuthenticatedAppSupervisorRouteRoute,
  } as any)
const AuthenticatedAppProfileAccountRoute =
  AuthenticatedAppProfileAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedAppProfileRouteRoute,
  } as any)
const AuthenticatedAppMetadataCollectionRoute =
  AuthenticatedAppMetadataCollectionRouteImport.update({
    id: '/$collection',
    path: '/$collection',
    getParentRoute: () => AuthenticatedAppMetadataRouteRoute,
  } as any)
const AuthenticatedAppFieldTodayRoute =
  AuthenticatedAppFieldTodayRouteImport.update({
    id: '/today',
    path: '/today',
    getParentRoute: () => AuthenticatedAppFieldRouteRoute,
  } as any)
const AuthenticatedAppFieldHistoryRoute =
  AuthenticatedAppFieldHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AuthenticatedAppFieldRouteRoute,
  } as any)
const AuthenticatedAppDevicesListRoute =
  AuthenticatedAppDevicesListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => AuthenticatedAppDevicesRouteRoute,
  } as any)
const AuthenticatedAppDevicesInactiveRoute =
  AuthenticatedAppDevicesInactiveRouteImport.update({
    id: '/inactive',
    path: '/inactive',
    getParentRoute: () => AuthenticatedAppDevicesRouteRoute,
  } as any)
const AuthenticatedAppDevicesInTransitRoute =
  AuthenticatedAppDevicesInTransitRouteImport.update({
    id: '/in-transit',
    path: '/in-transit',
    getParentRoute: () => AuthenticatedAppDevicesRouteRoute,
  } as any)
const AuthenticatedAppDeliveryDeliveryIdRoute =
  AuthenticatedAppDeliveryDeliveryIdRouteImport.update({
    id: '/$deliveryId',
    path: '/$deliveryId',
    getParentRoute: () => AuthenticatedAppDeliveryRouteRoute,
  } as any)
const AuthenticatedAppCalibrationWorkstationsRoute =
  AuthenticatedAppCalibrationWorkstationsRouteImport.update({
    id: '/workstations',
    path: '/workstations',
    getParentRoute: () => AuthenticatedAppCalibrationRouteRoute,
  } as any)
const AuthenticatedAppAdminOrganizationsRoute =
  AuthenticatedAppAdminOrganizationsRouteImport.update({
    id: '/admin/organizations',
    path: '/admin/organizations',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)
const AuthenticatedAppUserManagementRoleRouteRoute =
  AuthenticatedAppUserManagementRoleRouteRouteImport.update({
    id: '/role',
    path: '/role',
    getParentRoute: () => AuthenticatedAppUserManagementRouteRoute,
  } as any)
const AuthenticatedAppSupervisorTeamRouteRoute =
  AuthenticatedAppSupervisorTeamRouteRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedAppSupervisorRouteRoute,
  } as any)
const AuthenticatedAppSupervisorTaskAssignmentRouteRoute =
  AuthenticatedAppSupervisorTaskAssignmentRouteRouteImport.update({
    id: '/task-assignment',
    path: '/task-assignment',
    getParentRoute: () => AuthenticatedAppSupervisorRouteRoute,
  } as any)
const AuthenticatedAppCalibrationDevicesRouteRoute =
  AuthenticatedAppCalibrationDevicesRouteRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AuthenticatedAppCalibrationRouteRoute,
  } as any)
const AuthenticatedAppUserManagementRoleIndexRoute =
  AuthenticatedAppUserManagementRoleIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppUserManagementRoleRouteRoute,
  } as any)
const AuthenticatedAppSupervisorTeamIndexRoute =
  AuthenticatedAppSupervisorTeamIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppSupervisorTeamRouteRoute,
  } as any)
const AuthenticatedAppSupervisorTaskAssignmentIndexRoute =
  AuthenticatedAppSupervisorTaskAssignmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppSupervisorTaskAssignmentRouteRoute,
  } as any)
const AuthenticatedAppDevicesTypesIndexRoute =
  AuthenticatedAppDevicesTypesIndexRouteImport.update({
    id: '/types/',
    path: '/types/',
    getParentRoute: () => AuthenticatedAppDevicesRouteRoute,
  } as any)
const AuthenticatedAppCalibrationDevicesIndexRoute =
  AuthenticatedAppCalibrationDevicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppCalibrationDevicesRouteRoute,
  } as any)
const AuthenticatedWorkspaceUserManagementAccountUidRoute =
  AuthenticatedWorkspaceUserManagementAccountUidRouteImport.update({
    id: '/user-management/account/$uid',
    path: '/user-management/account/$uid',
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any)
const AuthenticatedWorkspaceFieldVisitsVisitIdRoute =
  AuthenticatedWorkspaceFieldVisitsVisitIdRouteImport.update({
    id: '/field/visits/$visitId',
    path: '/field/visits/$visitId',
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any)
const AuthenticatedAppUserManagementRolePermissionSetIdRoute =
  AuthenticatedAppUserManagementRolePermissionSetIdRouteImport.update({
    id: '/$permissionSetId',
    path: '/$permissionSetId',
    getParentRoute: () => AuthenticatedAppUserManagementRoleRouteRoute,
  } as any)
const AuthenticatedAppSupervisorTeamFieldActivityRoute =
  AuthenticatedAppSupervisorTeamFieldActivityRouteImport.update({
    id: '/field-activity',
    path: '/field-activity',
    getParentRoute: () => AuthenticatedAppSupervisorTeamRouteRoute,
  } as any)
const AuthenticatedAppSupervisorTeamCamerasRoute =
  AuthenticatedAppSupervisorTeamCamerasRouteImport.update({
    id: '/cameras',
    path: '/cameras',
    getParentRoute: () => AuthenticatedAppSupervisorTeamRouteRoute,
  } as any)
const AuthenticatedAppSupervisorTaskAssignmentNewRoute =
  AuthenticatedAppSupervisorTaskAssignmentNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAppSupervisorTaskAssignmentRouteRoute,
  } as any)
const AuthenticatedAppSupervisorTaskAssignmentRequestIdRoute =
  AuthenticatedAppSupervisorTaskAssignmentRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => AuthenticatedAppSupervisorTaskAssignmentRouteRoute,
  } as any)
const AuthenticatedAppRawFootageUploadsSessionIdRoute =
  AuthenticatedAppRawFootageUploadsSessionIdRouteImport.update({
    id: '/uploads/$sessionId',
    path: '/uploads/$sessionId',
    getParentRoute: () => AuthenticatedAppRawFootageRouteRoute,
  } as any)
const AuthenticatedAppCalibrationDevicesDeviceIdRoute =
  AuthenticatedAppCalibrationDevicesDeviceIdRouteImport.update({
    id: '/$deviceId',
    path: '/$deviceId',
    getParentRoute: () => AuthenticatedAppCalibrationDevicesRouteRoute,
  } as any)
const AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRoute =
  AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/organizations/$organizationId/',
    path: '/organizations/$organizationId/',
    getParentRoute: () => AuthenticatedAppRawFootageRouteRoute,
  } as any)
const AuthenticatedAppCalibrationDevicesDeviceIdIndexRoute =
  AuthenticatedAppCalibrationDevicesDeviceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppCalibrationDevicesDeviceIdRoute,
  } as any)
const AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRoute =
  AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRouteImport.update(
    {
      id: '/relocations/$organizationId/$projectId/$footageKey',
      path: '/relocations/$organizationId/$projectId/$footageKey',
      getParentRoute: () => AuthenticatedAppRoute,
    } as any,
  )
const AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRoute =
  AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRouteImport.update({
    id: '/mcap-segments/$assetId/$segmentId',
    path: '/mcap-segments/$assetId/$segmentId',
    getParentRoute: () => AuthenticatedAppRawFootageRouteRoute,
  } as any)
const AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRoute =
  AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRouteImport.update(
    {
      id: '/calibration/devices/$deviceId/sessions/$sessionId',
      path: '/calibration/devices/$deviceId/sessions/$sessionId',
      getParentRoute: () => AuthenticatedWorkspaceRoute,
    } as any,
  )
const AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRoute =
  AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRouteImport.update(
    {
      id: '/organizations/$organizationId/projects/$projectId',
      path: '/organizations/$organizationId/projects/$projectId',
      getParentRoute: () => AuthenticatedAppRawFootageRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedAppIndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/auth-action': typeof AuthAuthActionRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/invitation': typeof AuthInvitationRoute
  '/login': typeof AuthLoginRoute
  '/login-complete': typeof AuthLoginCompleteRoute
  '/session-expired': typeof AuthSessionExpiredRoute
  '/calibration': typeof AuthenticatedAppCalibrationRouteRouteWithChildren
  '/delivery': typeof AuthenticatedAppDeliveryRouteRouteWithChildren
  '/devices': typeof AuthenticatedAppDevicesRouteRouteWithChildren
  '/field': typeof AuthenticatedAppFieldRouteRouteWithChildren
  '/metadata': typeof AuthenticatedAppMetadataRouteRouteWithChildren
  '/profile': typeof AuthenticatedAppProfileRouteRouteWithChildren
  '/raw-footage': typeof AuthenticatedAppRawFootageRouteRouteWithChildren
  '/supervisor': typeof AuthenticatedAppSupervisorRouteRouteWithChildren
  '/user-management': typeof AuthenticatedAppUserManagementRouteRouteWithChildren
  '/mcp/authorize': typeof AuthMcpAuthorizeRoute
  '/transfers': typeof AuthenticatedAppTransfersRoute
  '/calibration/devices': typeof AuthenticatedAppCalibrationDevicesRouteRouteWithChildren
  '/supervisor/task-assignment': typeof AuthenticatedAppSupervisorTaskAssignmentRouteRouteWithChildren
  '/supervisor/team': typeof AuthenticatedAppSupervisorTeamRouteRouteWithChildren
  '/user-management/role': typeof AuthenticatedAppUserManagementRoleRouteRouteWithChildren
  '/admin/organizations': typeof AuthenticatedAppAdminOrganizationsRoute
  '/calibration/workstations': typeof AuthenticatedAppCalibrationWorkstationsRoute
  '/delivery/$deliveryId': typeof AuthenticatedAppDeliveryDeliveryIdRoute
  '/devices/in-transit': typeof AuthenticatedAppDevicesInTransitRoute
  '/devices/inactive': typeof AuthenticatedAppDevicesInactiveRoute
  '/devices/list': typeof AuthenticatedAppDevicesListRoute
  '/field/history': typeof AuthenticatedAppFieldHistoryRoute
  '/field/today': typeof AuthenticatedAppFieldTodayRoute
  '/metadata/$collection': typeof AuthenticatedAppMetadataCollectionRoute
  '/profile/account': typeof AuthenticatedAppProfileAccountRoute
  '/supervisor/assets': typeof AuthenticatedAppSupervisorAssetsRoute
  '/supervisor/segments': typeof AuthenticatedAppSupervisorSegmentsRoute
  '/user-management/account': typeof AuthenticatedAppUserManagementAccountRoute
  '/user-management/invitations': typeof AuthenticatedAppUserManagementInvitationsRoute
  '/assets/$assetId': typeof AuthenticatedWorkspaceAssetsAssetIdRoute
  '/devices/$deviceId': typeof AuthenticatedWorkspaceDevicesDeviceIdRoute
  '/delivery/': typeof AuthenticatedAppDeliveryIndexRoute
  '/field/': typeof AuthenticatedAppFieldIndexRoute
  '/raw-footage/': typeof AuthenticatedAppRawFootageIndexRoute
  '/supervisor/': typeof AuthenticatedAppSupervisorIndexRoute
  '/calibration/devices/$deviceId': typeof AuthenticatedAppCalibrationDevicesDeviceIdRouteWithChildren
  '/raw-footage/uploads/$sessionId': typeof AuthenticatedAppRawFootageUploadsSessionIdRoute
  '/supervisor/task-assignment/$requestId': typeof AuthenticatedAppSupervisorTaskAssignmentRequestIdRoute
  '/supervisor/task-assignment/new': typeof AuthenticatedAppSupervisorTaskAssignmentNewRoute
  '/supervisor/team/cameras': typeof AuthenticatedAppSupervisorTeamCamerasRoute
  '/supervisor/team/field-activity': typeof AuthenticatedAppSupervisorTeamFieldActivityRoute
  '/user-management/role/$permissionSetId': typeof AuthenticatedAppUserManagementRolePermissionSetIdRoute
  '/field/visits/$visitId': typeof AuthenticatedWorkspaceFieldVisitsVisitIdRoute
  '/user-management/account/$uid': typeof AuthenticatedWorkspaceUserManagementAccountUidRoute
  '/calibration/devices/': typeof AuthenticatedAppCalibrationDevicesIndexRoute
  '/devices/types/': typeof AuthenticatedAppDevicesTypesIndexRoute
  '/supervisor/task-assignment/': typeof AuthenticatedAppSupervisorTaskAssignmentIndexRoute
  '/supervisor/team/': typeof AuthenticatedAppSupervisorTeamIndexRoute
  '/user-management/role/': typeof AuthenticatedAppUserManagementRoleIndexRoute
  '/raw-footage/mcap-segments/$assetId/$segmentId': typeof AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRoute
  '/relocations/$organizationId/$projectId/$footageKey': typeof AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRoute
  '/calibration/devices/$deviceId/': typeof AuthenticatedAppCalibrationDevicesDeviceIdIndexRoute
  '/raw-footage/organizations/$organizationId/': typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRoute
  '/raw-footage/organizations/$organizationId/projects/$projectId': typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRoute
  '/calibration/devices/$deviceId/sessions/$sessionId': typeof AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedAppIndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/auth-action': typeof AuthAuthActionRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/invitation': typeof AuthInvitationRoute
  '/login': typeof AuthLoginRoute
  '/login-complete': typeof AuthLoginCompleteRoute
  '/session-expired': typeof AuthSessionExpiredRoute
  '/calibration': typeof AuthenticatedAppCalibrationRouteRouteWithChildren
  '/devices': typeof AuthenticatedAppDevicesRouteRouteWithChildren
  '/metadata': typeof AuthenticatedAppMetadataRouteRouteWithChildren
  '/profile': typeof AuthenticatedAppProfileRouteRouteWithChildren
  '/user-management': typeof AuthenticatedAppUserManagementRouteRouteWithChildren
  '/mcp/authorize': typeof AuthMcpAuthorizeRoute
  '/transfers': typeof AuthenticatedAppTransfersRoute
  '/admin/organizations': typeof AuthenticatedAppAdminOrganizationsRoute
  '/calibration/workstations': typeof AuthenticatedAppCalibrationWorkstationsRoute
  '/delivery/$deliveryId': typeof AuthenticatedAppDeliveryDeliveryIdRoute
  '/devices/in-transit': typeof AuthenticatedAppDevicesInTransitRoute
  '/devices/inactive': typeof AuthenticatedAppDevicesInactiveRoute
  '/devices/list': typeof AuthenticatedAppDevicesListRoute
  '/field/history': typeof AuthenticatedAppFieldHistoryRoute
  '/field/today': typeof AuthenticatedAppFieldTodayRoute
  '/metadata/$collection': typeof AuthenticatedAppMetadataCollectionRoute
  '/profile/account': typeof AuthenticatedAppProfileAccountRoute
  '/supervisor/assets': typeof AuthenticatedAppSupervisorAssetsRoute
  '/supervisor/segments': typeof AuthenticatedAppSupervisorSegmentsRoute
  '/user-management/account': typeof AuthenticatedAppUserManagementAccountRoute
  '/user-management/invitations': typeof AuthenticatedAppUserManagementInvitationsRoute
  '/assets/$assetId': typeof AuthenticatedWorkspaceAssetsAssetIdRoute
  '/devices/$deviceId': typeof AuthenticatedWorkspaceDevicesDeviceIdRoute
  '/delivery': typeof AuthenticatedAppDeliveryIndexRoute
  '/field': typeof AuthenticatedAppFieldIndexRoute
  '/raw-footage': typeof AuthenticatedAppRawFootageIndexRoute
  '/supervisor': typeof AuthenticatedAppSupervisorIndexRoute
  '/raw-footage/uploads/$sessionId': typeof AuthenticatedAppRawFootageUploadsSessionIdRoute
  '/supervisor/task-assignment/$requestId': typeof AuthenticatedAppSupervisorTaskAssignmentRequestIdRoute
  '/supervisor/task-assignment/new': typeof AuthenticatedAppSupervisorTaskAssignmentNewRoute
  '/supervisor/team/cameras': typeof AuthenticatedAppSupervisorTeamCamerasRoute
  '/supervisor/team/field-activity': typeof AuthenticatedAppSupervisorTeamFieldActivityRoute
  '/user-management/role/$permissionSetId': typeof AuthenticatedAppUserManagementRolePermissionSetIdRoute
  '/field/visits/$visitId': typeof AuthenticatedWorkspaceFieldVisitsVisitIdRoute
  '/user-management/account/$uid': typeof AuthenticatedWorkspaceUserManagementAccountUidRoute
  '/calibration/devices': typeof AuthenticatedAppCalibrationDevicesIndexRoute
  '/devices/types': typeof AuthenticatedAppDevicesTypesIndexRoute
  '/supervisor/task-assignment': typeof AuthenticatedAppSupervisorTaskAssignmentIndexRoute
  '/supervisor/team': typeof AuthenticatedAppSupervisorTeamIndexRoute
  '/user-management/role': typeof AuthenticatedAppUserManagementRoleIndexRoute
  '/raw-footage/mcap-segments/$assetId/$segmentId': typeof AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRoute
  '/relocations/$organizationId/$projectId/$footageKey': typeof AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRoute
  '/calibration/devices/$deviceId': typeof AuthenticatedAppCalibrationDevicesDeviceIdIndexRoute
  '/raw-footage/organizations/$organizationId': typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRoute
  '/raw-footage/organizations/$organizationId/projects/$projectId': typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRoute
  '/calibration/devices/$deviceId/sessions/$sessionId': typeof AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/_auth/auth-action': typeof AuthAuthActionRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/invitation': typeof AuthInvitationRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/login-complete': typeof AuthLoginCompleteRoute
  '/_auth/session-expired': typeof AuthSessionExpiredRoute
  '/_authenticated/_app': typeof AuthenticatedAppRouteWithChildren
  '/_authenticated/_workspace': typeof AuthenticatedWorkspaceRouteWithChildren
  '/_authenticated/_app/calibration': typeof AuthenticatedAppCalibrationRouteRouteWithChildren
  '/_authenticated/_app/delivery': typeof AuthenticatedAppDeliveryRouteRouteWithChildren
  '/_authenticated/_app/devices': typeof AuthenticatedAppDevicesRouteRouteWithChildren
  '/_authenticated/_app/field': typeof AuthenticatedAppFieldRouteRouteWithChildren
  '/_authenticated/_app/metadata': typeof AuthenticatedAppMetadataRouteRouteWithChildren
  '/_authenticated/_app/profile': typeof AuthenticatedAppProfileRouteRouteWithChildren
  '/_authenticated/_app/raw-footage': typeof AuthenticatedAppRawFootageRouteRouteWithChildren
  '/_authenticated/_app/supervisor': typeof AuthenticatedAppSupervisorRouteRouteWithChildren
  '/_authenticated/_app/user-management': typeof AuthenticatedAppUserManagementRouteRouteWithChildren
  '/_auth/mcp/authorize': typeof AuthMcpAuthorizeRoute
  '/_authenticated/_app/transfers': typeof AuthenticatedAppTransfersRoute
  '/_authenticated/_app/': typeof AuthenticatedAppIndexRoute
  '/_authenticated/_app/calibration/devices': typeof AuthenticatedAppCalibrationDevicesRouteRouteWithChildren
  '/_authenticated/_app/supervisor/task-assignment': typeof AuthenticatedAppSupervisorTaskAssignmentRouteRouteWithChildren
  '/_authenticated/_app/supervisor/team': typeof AuthenticatedAppSupervisorTeamRouteRouteWithChildren
  '/_authenticated/_app/user-management/role': typeof AuthenticatedAppUserManagementRoleRouteRouteWithChildren
  '/_authenticated/_app/admin/organizations': typeof AuthenticatedAppAdminOrganizationsRoute
  '/_authenticated/_app/calibration/workstations': typeof AuthenticatedAppCalibrationWorkstationsRoute
  '/_authenticated/_app/delivery/$deliveryId': typeof AuthenticatedAppDeliveryDeliveryIdRoute
  '/_authenticated/_app/devices/in-transit': typeof AuthenticatedAppDevicesInTransitRoute
  '/_authenticated/_app/devices/inactive': typeof AuthenticatedAppDevicesInactiveRoute
  '/_authenticated/_app/devices/list': typeof AuthenticatedAppDevicesListRoute
  '/_authenticated/_app/field/history': typeof AuthenticatedAppFieldHistoryRoute
  '/_authenticated/_app/field/today': typeof AuthenticatedAppFieldTodayRoute
  '/_authenticated/_app/metadata/$collection': typeof AuthenticatedAppMetadataCollectionRoute
  '/_authenticated/_app/profile/account': typeof AuthenticatedAppProfileAccountRoute
  '/_authenticated/_app/supervisor/assets': typeof AuthenticatedAppSupervisorAssetsRoute
  '/_authenticated/_app/supervisor/segments': typeof AuthenticatedAppSupervisorSegmentsRoute
  '/_authenticated/_app/user-management/account': typeof AuthenticatedAppUserManagementAccountRoute
  '/_authenticated/_app/user-management/invitations': typeof AuthenticatedAppUserManagementInvitationsRoute
  '/_authenticated/_workspace/assets/$assetId': typeof AuthenticatedWorkspaceAssetsAssetIdRoute
  '/_authenticated/_workspace/devices/$deviceId': typeof AuthenticatedWorkspaceDevicesDeviceIdRoute
  '/_authenticated/_app/delivery/': typeof AuthenticatedAppDeliveryIndexRoute
  '/_authenticated/_app/field/': typeof AuthenticatedAppFieldIndexRoute
  '/_authenticated/_app/raw-footage/': typeof AuthenticatedAppRawFootageIndexRoute
  '/_authenticated/_app/supervisor/': typeof AuthenticatedAppSupervisorIndexRoute
  '/_authenticated/_app/calibration/devices/$deviceId': typeof AuthenticatedAppCalibrationDevicesDeviceIdRouteWithChildren
  '/_authenticated/_app/raw-footage/uploads/$sessionId': typeof AuthenticatedAppRawFootageUploadsSessionIdRoute
  '/_authenticated/_app/supervisor/task-assignment/$requestId': typeof AuthenticatedAppSupervisorTaskAssignmentRequestIdRoute
  '/_authenticated/_app/supervisor/task-assignment/new': typeof AuthenticatedAppSupervisorTaskAssignmentNewRoute
  '/_authenticated/_app/supervisor/team/cameras': typeof AuthenticatedAppSupervisorTeamCamerasRoute
  '/_authenticated/_app/supervisor/team/field-activity': typeof AuthenticatedAppSupervisorTeamFieldActivityRoute
  '/_authenticated/_app/user-management/role/$permissionSetId': typeof AuthenticatedAppUserManagementRolePermissionSetIdRoute
  '/_authenticated/_workspace/field/visits/$visitId': typeof AuthenticatedWorkspaceFieldVisitsVisitIdRoute
  '/_authenticated/_workspace/user-management/account/$uid': typeof AuthenticatedWorkspaceUserManagementAccountUidRoute
  '/_authenticated/_app/calibration/devices/': typeof AuthenticatedAppCalibrationDevicesIndexRoute
  '/_authenticated/_app/devices/types/': typeof AuthenticatedAppDevicesTypesIndexRoute
  '/_authenticated/_app/supervisor/task-assignment/': typeof AuthenticatedAppSupervisorTaskAssignmentIndexRoute
  '/_authenticated/_app/supervisor/team/': typeof AuthenticatedAppSupervisorTeamIndexRoute
  '/_authenticated/_app/user-management/role/': typeof AuthenticatedAppUserManagementRoleIndexRoute
  '/_authenticated/_app/raw-footage/mcap-segments/$assetId/$segmentId': typeof AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRoute
  '/_authenticated/_app/relocations/$organizationId/$projectId/$footageKey': typeof AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRoute
  '/_authenticated/_app/calibration/devices/$deviceId/': typeof AuthenticatedAppCalibrationDevicesDeviceIdIndexRoute
  '/_authenticated/_app/raw-footage/organizations/$organizationId/': typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRoute
  '/_authenticated/_app/raw-footage/organizations/$organizationId/projects/$projectId': typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRoute
  '/_authenticated/_workspace/calibration/devices/$deviceId/sessions/$sessionId': typeof AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forbidden'
    | '/auth-action'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/login-complete'
    | '/session-expired'
    | '/calibration'
    | '/delivery'
    | '/devices'
    | '/field'
    | '/metadata'
    | '/profile'
    | '/raw-footage'
    | '/supervisor'
    | '/user-management'
    | '/mcp/authorize'
    | '/transfers'
    | '/calibration/devices'
    | '/supervisor/task-assignment'
    | '/supervisor/team'
    | '/user-management/role'
    | '/admin/organizations'
    | '/calibration/workstations'
    | '/delivery/$deliveryId'
    | '/devices/in-transit'
    | '/devices/inactive'
    | '/devices/list'
    | '/field/history'
    | '/field/today'
    | '/metadata/$collection'
    | '/profile/account'
    | '/supervisor/assets'
    | '/supervisor/segments'
    | '/user-management/account'
    | '/user-management/invitations'
    | '/assets/$assetId'
    | '/devices/$deviceId'
    | '/delivery/'
    | '/field/'
    | '/raw-footage/'
    | '/supervisor/'
    | '/calibration/devices/$deviceId'
    | '/raw-footage/uploads/$sessionId'
    | '/supervisor/task-assignment/$requestId'
    | '/supervisor/task-assignment/new'
    | '/supervisor/team/cameras'
    | '/supervisor/team/field-activity'
    | '/user-management/role/$permissionSetId'
    | '/field/visits/$visitId'
    | '/user-management/account/$uid'
    | '/calibration/devices/'
    | '/devices/types/'
    | '/supervisor/task-assignment/'
    | '/supervisor/team/'
    | '/user-management/role/'
    | '/raw-footage/mcap-segments/$assetId/$segmentId'
    | '/relocations/$organizationId/$projectId/$footageKey'
    | '/calibration/devices/$deviceId/'
    | '/raw-footage/organizations/$organizationId/'
    | '/raw-footage/organizations/$organizationId/projects/$projectId'
    | '/calibration/devices/$deviceId/sessions/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forbidden'
    | '/auth-action'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/login-complete'
    | '/session-expired'
    | '/calibration'
    | '/devices'
    | '/metadata'
    | '/profile'
    | '/user-management'
    | '/mcp/authorize'
    | '/transfers'
    | '/admin/organizations'
    | '/calibration/workstations'
    | '/delivery/$deliveryId'
    | '/devices/in-transit'
    | '/devices/inactive'
    | '/devices/list'
    | '/field/history'
    | '/field/today'
    | '/metadata/$collection'
    | '/profile/account'
    | '/supervisor/assets'
    | '/supervisor/segments'
    | '/user-management/account'
    | '/user-management/invitations'
    | '/assets/$assetId'
    | '/devices/$deviceId'
    | '/delivery'
    | '/field'
    | '/raw-footage'
    | '/supervisor'
    | '/raw-footage/uploads/$sessionId'
    | '/supervisor/task-assignment/$requestId'
    | '/supervisor/task-assignment/new'
    | '/supervisor/team/cameras'
    | '/supervisor/team/field-activity'
    | '/user-management/role/$permissionSetId'
    | '/field/visits/$visitId'
    | '/user-management/account/$uid'
    | '/calibration/devices'
    | '/devices/types'
    | '/supervisor/task-assignment'
    | '/supervisor/team'
    | '/user-management/role'
    | '/raw-footage/mcap-segments/$assetId/$segmentId'
    | '/relocations/$organizationId/$projectId/$footageKey'
    | '/calibration/devices/$deviceId'
    | '/raw-footage/organizations/$organizationId'
    | '/raw-footage/organizations/$organizationId/projects/$projectId'
    | '/calibration/devices/$deviceId/sessions/$sessionId'
  id:
    | '__root__'
    | '/_auth'
    | '/_authenticated'
    | '/forbidden'
    | '/_auth/auth-action'
    | '/_auth/forgot-password'
    | '/_auth/invitation'
    | '/_auth/login'
    | '/_auth/login-complete'
    | '/_auth/session-expired'
    | '/_authenticated/_app'
    | '/_authenticated/_workspace'
    | '/_authenticated/_app/calibration'
    | '/_authenticated/_app/delivery'
    | '/_authenticated/_app/devices'
    | '/_authenticated/_app/field'
    | '/_authenticated/_app/metadata'
    | '/_authenticated/_app/profile'
    | '/_authenticated/_app/raw-footage'
    | '/_authenticated/_app/supervisor'
    | '/_authenticated/_app/user-management'
    | '/_auth/mcp/authorize'
    | '/_authenticated/_app/transfers'
    | '/_authenticated/_app/'
    | '/_authenticated/_app/calibration/devices'
    | '/_authenticated/_app/supervisor/task-assignment'
    | '/_authenticated/_app/supervisor/team'
    | '/_authenticated/_app/user-management/role'
    | '/_authenticated/_app/admin/organizations'
    | '/_authenticated/_app/calibration/workstations'
    | '/_authenticated/_app/delivery/$deliveryId'
    | '/_authenticated/_app/devices/in-transit'
    | '/_authenticated/_app/devices/inactive'
    | '/_authenticated/_app/devices/list'
    | '/_authenticated/_app/field/history'
    | '/_authenticated/_app/field/today'
    | '/_authenticated/_app/metadata/$collection'
    | '/_authenticated/_app/profile/account'
    | '/_authenticated/_app/supervisor/assets'
    | '/_authenticated/_app/supervisor/segments'
    | '/_authenticated/_app/user-management/account'
    | '/_authenticated/_app/user-management/invitations'
    | '/_authenticated/_workspace/assets/$assetId'
    | '/_authenticated/_workspace/devices/$deviceId'
    | '/_authenticated/_app/delivery/'
    | '/_authenticated/_app/field/'
    | '/_authenticated/_app/raw-footage/'
    | '/_authenticated/_app/supervisor/'
    | '/_authenticated/_app/calibration/devices/$deviceId'
    | '/_authenticated/_app/raw-footage/uploads/$sessionId'
    | '/_authenticated/_app/supervisor/task-assignment/$requestId'
    | '/_authenticated/_app/supervisor/task-assignment/new'
    | '/_authenticated/_app/supervisor/team/cameras'
    | '/_authenticated/_app/supervisor/team/field-activity'
    | '/_authenticated/_app/user-management/role/$permissionSetId'
    | '/_authenticated/_workspace/field/visits/$visitId'
    | '/_authenticated/_workspace/user-management/account/$uid'
    | '/_authenticated/_app/calibration/devices/'
    | '/_authenticated/_app/devices/types/'
    | '/_authenticated/_app/supervisor/task-assignment/'
    | '/_authenticated/_app/supervisor/team/'
    | '/_authenticated/_app/user-management/role/'
    | '/_authenticated/_app/raw-footage/mcap-segments/$assetId/$segmentId'
    | '/_authenticated/_app/relocations/$organizationId/$projectId/$footageKey'
    | '/_authenticated/_app/calibration/devices/$deviceId/'
    | '/_authenticated/_app/raw-footage/organizations/$organizationId/'
    | '/_authenticated/_app/raw-footage/organizations/$organizationId/projects/$projectId'
    | '/_authenticated/_workspace/calibration/devices/$deviceId/sessions/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_workspace': {
      id: '/_authenticated/_workspace'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedWorkspaceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_app': {
      id: '/_authenticated/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedAppRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/session-expired': {
      id: '/_auth/session-expired'
      path: '/session-expired'
      fullPath: '/session-expired'
      preLoaderRoute: typeof AuthSessionExpiredRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login-complete': {
      id: '/_auth/login-complete'
      path: '/login-complete'
      fullPath: '/login-complete'
      preLoaderRoute: typeof AuthLoginCompleteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invitation': {
      id: '/_auth/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof AuthInvitationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth-action': {
      id: '/_auth/auth-action'
      path: '/auth-action'
      fullPath: '/auth-action'
      preLoaderRoute: typeof AuthAuthActionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/_app/': {
      id: '/_authenticated/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedAppIndexRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/transfers': {
      id: '/_authenticated/_app/transfers'
      path: '/transfers'
      fullPath: '/transfers'
      preLoaderRoute: typeof AuthenticatedAppTransfersRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_auth/mcp/authorize': {
      id: '/_auth/mcp/authorize'
      path: '/mcp/authorize'
      fullPath: '/mcp/authorize'
      preLoaderRoute: typeof AuthMcpAuthorizeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/_app/user-management': {
      id: '/_authenticated/_app/user-management'
      path: '/user-management'
      fullPath: '/user-management'
      preLoaderRoute: typeof AuthenticatedAppUserManagementRouteRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/supervisor': {
      id: '/_authenticated/_app/supervisor'
      path: '/supervisor'
      fullPath: '/supervisor'
      preLoaderRoute: typeof AuthenticatedAppSupervisorRouteRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/raw-footage': {
      id: '/_authenticated/_app/raw-footage'
      path: '/raw-footage'
      fullPath: '/raw-footage'
      preLoaderRoute: typeof AuthenticatedAppRawFootageRouteRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/profile': {
      id: '/_authenticated/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedAppProfileRouteRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/metadata': {
      id: '/_authenticated/_app/metadata'
      path: '/metadata'
      fullPath: '/metadata'
      preLoaderRoute: typeof AuthenticatedAppMetadataRouteRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/field': {
      id: '/_authenticated/_app/field'
      path: '/field'
      fullPath: '/field'
      preLoaderRoute: typeof AuthenticatedAppFieldRouteRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/devices': {
      id: '/_authenticated/_app/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AuthenticatedAppDevicesRouteRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/delivery': {
      id: '/_authenticated/_app/delivery'
      path: '/delivery'
      fullPath: '/delivery'
      preLoaderRoute: typeof AuthenticatedAppDeliveryRouteRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/calibration': {
      id: '/_authenticated/_app/calibration'
      path: '/calibration'
      fullPath: '/calibration'
      preLoaderRoute: typeof AuthenticatedAppCalibrationRouteRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/supervisor/': {
      id: '/_authenticated/_app/supervisor/'
      path: '/'
      fullPath: '/supervisor/'
      preLoaderRoute: typeof AuthenticatedAppSupervisorIndexRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorRouteRoute
    }
    '/_authenticated/_app/raw-footage/': {
      id: '/_authenticated/_app/raw-footage/'
      path: '/'
      fullPath: '/raw-footage/'
      preLoaderRoute: typeof AuthenticatedAppRawFootageIndexRouteImport
      parentRoute: typeof AuthenticatedAppRawFootageRouteRoute
    }
    '/_authenticated/_app/field/': {
      id: '/_authenticated/_app/field/'
      path: '/'
      fullPath: '/field/'
      preLoaderRoute: typeof AuthenticatedAppFieldIndexRouteImport
      parentRoute: typeof AuthenticatedAppFieldRouteRoute
    }
    '/_authenticated/_app/delivery/': {
      id: '/_authenticated/_app/delivery/'
      path: '/'
      fullPath: '/delivery/'
      preLoaderRoute: typeof AuthenticatedAppDeliveryIndexRouteImport
      parentRoute: typeof AuthenticatedAppDeliveryRouteRoute
    }
    '/_authenticated/_workspace/devices/$deviceId': {
      id: '/_authenticated/_workspace/devices/$deviceId'
      path: '/devices/$deviceId'
      fullPath: '/devices/$deviceId'
      preLoaderRoute: typeof AuthenticatedWorkspaceDevicesDeviceIdRouteImport
      parentRoute: typeof AuthenticatedWorkspaceRoute
    }
    '/_authenticated/_workspace/assets/$assetId': {
      id: '/_authenticated/_workspace/assets/$assetId'
      path: '/assets/$assetId'
      fullPath: '/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedWorkspaceAssetsAssetIdRouteImport
      parentRoute: typeof AuthenticatedWorkspaceRoute
    }
    '/_authenticated/_app/user-management/invitations': {
      id: '/_authenticated/_app/user-management/invitations'
      path: '/invitations'
      fullPath: '/user-management/invitations'
      preLoaderRoute: typeof AuthenticatedAppUserManagementInvitationsRouteImport
      parentRoute: typeof AuthenticatedAppUserManagementRouteRoute
    }
    '/_authenticated/_app/user-management/account': {
      id: '/_authenticated/_app/user-management/account'
      path: '/account'
      fullPath: '/user-management/account'
      preLoaderRoute: typeof AuthenticatedAppUserManagementAccountRouteImport
      parentRoute: typeof AuthenticatedAppUserManagementRouteRoute
    }
    '/_authenticated/_app/supervisor/segments': {
      id: '/_authenticated/_app/supervisor/segments'
      path: '/segments'
      fullPath: '/supervisor/segments'
      preLoaderRoute: typeof AuthenticatedAppSupervisorSegmentsRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorRouteRoute
    }
    '/_authenticated/_app/supervisor/assets': {
      id: '/_authenticated/_app/supervisor/assets'
      path: '/assets'
      fullPath: '/supervisor/assets'
      preLoaderRoute: typeof AuthenticatedAppSupervisorAssetsRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorRouteRoute
    }
    '/_authenticated/_app/profile/account': {
      id: '/_authenticated/_app/profile/account'
      path: '/account'
      fullPath: '/profile/account'
      preLoaderRoute: typeof AuthenticatedAppProfileAccountRouteImport
      parentRoute: typeof AuthenticatedAppProfileRouteRoute
    }
    '/_authenticated/_app/metadata/$collection': {
      id: '/_authenticated/_app/metadata/$collection'
      path: '/$collection'
      fullPath: '/metadata/$collection'
      preLoaderRoute: typeof AuthenticatedAppMetadataCollectionRouteImport
      parentRoute: typeof AuthenticatedAppMetadataRouteRoute
    }
    '/_authenticated/_app/field/today': {
      id: '/_authenticated/_app/field/today'
      path: '/today'
      fullPath: '/field/today'
      preLoaderRoute: typeof AuthenticatedAppFieldTodayRouteImport
      parentRoute: typeof AuthenticatedAppFieldRouteRoute
    }
    '/_authenticated/_app/field/history': {
      id: '/_authenticated/_app/field/history'
      path: '/history'
      fullPath: '/field/history'
      preLoaderRoute: typeof AuthenticatedAppFieldHistoryRouteImport
      parentRoute: typeof AuthenticatedAppFieldRouteRoute
    }
    '/_authenticated/_app/devices/list': {
      id: '/_authenticated/_app/devices/list'
      path: '/list'
      fullPath: '/devices/list'
      preLoaderRoute: typeof AuthenticatedAppDevicesListRouteImport
      parentRoute: typeof AuthenticatedAppDevicesRouteRoute
    }
    '/_authenticated/_app/devices/inactive': {
      id: '/_authenticated/_app/devices/inactive'
      path: '/inactive'
      fullPath: '/devices/inactive'
      preLoaderRoute: typeof AuthenticatedAppDevicesInactiveRouteImport
      parentRoute: typeof AuthenticatedAppDevicesRouteRoute
    }
    '/_authenticated/_app/devices/in-transit': {
      id: '/_authenticated/_app/devices/in-transit'
      path: '/in-transit'
      fullPath: '/devices/in-transit'
      preLoaderRoute: typeof AuthenticatedAppDevicesInTransitRouteImport
      parentRoute: typeof AuthenticatedAppDevicesRouteRoute
    }
    '/_authenticated/_app/delivery/$deliveryId': {
      id: '/_authenticated/_app/delivery/$deliveryId'
      path: '/$deliveryId'
      fullPath: '/delivery/$deliveryId'
      preLoaderRoute: typeof AuthenticatedAppDeliveryDeliveryIdRouteImport
      parentRoute: typeof AuthenticatedAppDeliveryRouteRoute
    }
    '/_authenticated/_app/calibration/workstations': {
      id: '/_authenticated/_app/calibration/workstations'
      path: '/workstations'
      fullPath: '/calibration/workstations'
      preLoaderRoute: typeof AuthenticatedAppCalibrationWorkstationsRouteImport
      parentRoute: typeof AuthenticatedAppCalibrationRouteRoute
    }
    '/_authenticated/_app/admin/organizations': {
      id: '/_authenticated/_app/admin/organizations'
      path: '/admin/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AuthenticatedAppAdminOrganizationsRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/user-management/role': {
      id: '/_authenticated/_app/user-management/role'
      path: '/role'
      fullPath: '/user-management/role'
      preLoaderRoute: typeof AuthenticatedAppUserManagementRoleRouteRouteImport
      parentRoute: typeof AuthenticatedAppUserManagementRouteRoute
    }
    '/_authenticated/_app/supervisor/team': {
      id: '/_authenticated/_app/supervisor/team'
      path: '/team'
      fullPath: '/supervisor/team'
      preLoaderRoute: typeof AuthenticatedAppSupervisorTeamRouteRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorRouteRoute
    }
    '/_authenticated/_app/supervisor/task-assignment': {
      id: '/_authenticated/_app/supervisor/task-assignment'
      path: '/task-assignment'
      fullPath: '/supervisor/task-assignment'
      preLoaderRoute: typeof AuthenticatedAppSupervisorTaskAssignmentRouteRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorRouteRoute
    }
    '/_authenticated/_app/calibration/devices': {
      id: '/_authenticated/_app/calibration/devices'
      path: '/devices'
      fullPath: '/calibration/devices'
      preLoaderRoute: typeof AuthenticatedAppCalibrationDevicesRouteRouteImport
      parentRoute: typeof AuthenticatedAppCalibrationRouteRoute
    }
    '/_authenticated/_app/user-management/role/': {
      id: '/_authenticated/_app/user-management/role/'
      path: '/'
      fullPath: '/user-management/role/'
      preLoaderRoute: typeof AuthenticatedAppUserManagementRoleIndexRouteImport
      parentRoute: typeof AuthenticatedAppUserManagementRoleRouteRoute
    }
    '/_authenticated/_app/supervisor/team/': {
      id: '/_authenticated/_app/supervisor/team/'
      path: '/'
      fullPath: '/supervisor/team/'
      preLoaderRoute: typeof AuthenticatedAppSupervisorTeamIndexRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorTeamRouteRoute
    }
    '/_authenticated/_app/supervisor/task-assignment/': {
      id: '/_authenticated/_app/supervisor/task-assignment/'
      path: '/'
      fullPath: '/supervisor/task-assignment/'
      preLoaderRoute: typeof AuthenticatedAppSupervisorTaskAssignmentIndexRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorTaskAssignmentRouteRoute
    }
    '/_authenticated/_app/devices/types/': {
      id: '/_authenticated/_app/devices/types/'
      path: '/types'
      fullPath: '/devices/types/'
      preLoaderRoute: typeof AuthenticatedAppDevicesTypesIndexRouteImport
      parentRoute: typeof AuthenticatedAppDevicesRouteRoute
    }
    '/_authenticated/_app/calibration/devices/': {
      id: '/_authenticated/_app/calibration/devices/'
      path: '/'
      fullPath: '/calibration/devices/'
      preLoaderRoute: typeof AuthenticatedAppCalibrationDevicesIndexRouteImport
      parentRoute: typeof AuthenticatedAppCalibrationDevicesRouteRoute
    }
    '/_authenticated/_workspace/user-management/account/$uid': {
      id: '/_authenticated/_workspace/user-management/account/$uid'
      path: '/user-management/account/$uid'
      fullPath: '/user-management/account/$uid'
      preLoaderRoute: typeof AuthenticatedWorkspaceUserManagementAccountUidRouteImport
      parentRoute: typeof AuthenticatedWorkspaceRoute
    }
    '/_authenticated/_workspace/field/visits/$visitId': {
      id: '/_authenticated/_workspace/field/visits/$visitId'
      path: '/field/visits/$visitId'
      fullPath: '/field/visits/$visitId'
      preLoaderRoute: typeof AuthenticatedWorkspaceFieldVisitsVisitIdRouteImport
      parentRoute: typeof AuthenticatedWorkspaceRoute
    }
    '/_authenticated/_app/user-management/role/$permissionSetId': {
      id: '/_authenticated/_app/user-management/role/$permissionSetId'
      path: '/$permissionSetId'
      fullPath: '/user-management/role/$permissionSetId'
      preLoaderRoute: typeof AuthenticatedAppUserManagementRolePermissionSetIdRouteImport
      parentRoute: typeof AuthenticatedAppUserManagementRoleRouteRoute
    }
    '/_authenticated/_app/supervisor/team/field-activity': {
      id: '/_authenticated/_app/supervisor/team/field-activity'
      path: '/field-activity'
      fullPath: '/supervisor/team/field-activity'
      preLoaderRoute: typeof AuthenticatedAppSupervisorTeamFieldActivityRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorTeamRouteRoute
    }
    '/_authenticated/_app/supervisor/team/cameras': {
      id: '/_authenticated/_app/supervisor/team/cameras'
      path: '/cameras'
      fullPath: '/supervisor/team/cameras'
      preLoaderRoute: typeof AuthenticatedAppSupervisorTeamCamerasRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorTeamRouteRoute
    }
    '/_authenticated/_app/supervisor/task-assignment/new': {
      id: '/_authenticated/_app/supervisor/task-assignment/new'
      path: '/new'
      fullPath: '/supervisor/task-assignment/new'
      preLoaderRoute: typeof AuthenticatedAppSupervisorTaskAssignmentNewRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorTaskAssignmentRouteRoute
    }
    '/_authenticated/_app/supervisor/task-assignment/$requestId': {
      id: '/_authenticated/_app/supervisor/task-assignment/$requestId'
      path: '/$requestId'
      fullPath: '/supervisor/task-assignment/$requestId'
      preLoaderRoute: typeof AuthenticatedAppSupervisorTaskAssignmentRequestIdRouteImport
      parentRoute: typeof AuthenticatedAppSupervisorTaskAssignmentRouteRoute
    }
    '/_authenticated/_app/raw-footage/uploads/$sessionId': {
      id: '/_authenticated/_app/raw-footage/uploads/$sessionId'
      path: '/uploads/$sessionId'
      fullPath: '/raw-footage/uploads/$sessionId'
      preLoaderRoute: typeof AuthenticatedAppRawFootageUploadsSessionIdRouteImport
      parentRoute: typeof AuthenticatedAppRawFootageRouteRoute
    }
    '/_authenticated/_app/calibration/devices/$deviceId': {
      id: '/_authenticated/_app/calibration/devices/$deviceId'
      path: '/$deviceId'
      fullPath: '/calibration/devices/$deviceId'
      preLoaderRoute: typeof AuthenticatedAppCalibrationDevicesDeviceIdRouteImport
      parentRoute: typeof AuthenticatedAppCalibrationDevicesRouteRoute
    }
    '/_authenticated/_app/raw-footage/organizations/$organizationId/': {
      id: '/_authenticated/_app/raw-footage/organizations/$organizationId/'
      path: '/organizations/$organizationId'
      fullPath: '/raw-footage/organizations/$organizationId/'
      preLoaderRoute: typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthenticatedAppRawFootageRouteRoute
    }
    '/_authenticated/_app/calibration/devices/$deviceId/': {
      id: '/_authenticated/_app/calibration/devices/$deviceId/'
      path: '/'
      fullPath: '/calibration/devices/$deviceId/'
      preLoaderRoute: typeof AuthenticatedAppCalibrationDevicesDeviceIdIndexRouteImport
      parentRoute: typeof AuthenticatedAppCalibrationDevicesDeviceIdRoute
    }
    '/_authenticated/_app/relocations/$organizationId/$projectId/$footageKey': {
      id: '/_authenticated/_app/relocations/$organizationId/$projectId/$footageKey'
      path: '/relocations/$organizationId/$projectId/$footageKey'
      fullPath: '/relocations/$organizationId/$projectId/$footageKey'
      preLoaderRoute: typeof AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRouteImport
      parentRoute: typeof AuthenticatedAppRoute
    }
    '/_authenticated/_app/raw-footage/mcap-segments/$assetId/$segmentId': {
      id: '/_authenticated/_app/raw-footage/mcap-segments/$assetId/$segmentId'
      path: '/mcap-segments/$assetId/$segmentId'
      fullPath: '/raw-footage/mcap-segments/$assetId/$segmentId'
      preLoaderRoute: typeof AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRouteImport
      parentRoute: typeof AuthenticatedAppRawFootageRouteRoute
    }
    '/_authenticated/_workspace/calibration/devices/$deviceId/sessions/$sessionId': {
      id: '/_authenticated/_workspace/calibration/devices/$deviceId/sessions/$sessionId'
      path: '/calibration/devices/$deviceId/sessions/$sessionId'
      fullPath: '/calibration/devices/$deviceId/sessions/$sessionId'
      preLoaderRoute: typeof AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRouteImport
      parentRoute: typeof AuthenticatedWorkspaceRoute
    }
    '/_authenticated/_app/raw-footage/organizations/$organizationId/projects/$projectId': {
      id: '/_authenticated/_app/raw-footage/organizations/$organizationId/projects/$projectId'
      path: '/organizations/$organizationId/projects/$projectId'
      fullPath: '/raw-footage/organizations/$organizationId/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedAppRawFootageRouteRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAuthActionRoute: typeof AuthAuthActionRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthInvitationRoute: typeof AuthInvitationRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLoginCompleteRoute: typeof AuthLoginCompleteRoute
  AuthSessionExpiredRoute: typeof AuthSessionExpiredRoute
  AuthMcpAuthorizeRoute: typeof AuthMcpAuthorizeRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuthActionRoute: AuthAuthActionRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthInvitationRoute: AuthInvitationRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLoginCompleteRoute: AuthLoginCompleteRoute,
  AuthSessionExpiredRoute: AuthSessionExpiredRoute,
  AuthMcpAuthorizeRoute: AuthMcpAuthorizeRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedAppCalibrationDevicesDeviceIdRouteChildren {
  AuthenticatedAppCalibrationDevicesDeviceIdIndexRoute: typeof AuthenticatedAppCalibrationDevicesDeviceIdIndexRoute
}

const AuthenticatedAppCalibrationDevicesDeviceIdRouteChildren: AuthenticatedAppCalibrationDevicesDeviceIdRouteChildren =
  {
    AuthenticatedAppCalibrationDevicesDeviceIdIndexRoute:
      AuthenticatedAppCalibrationDevicesDeviceIdIndexRoute,
  }

const AuthenticatedAppCalibrationDevicesDeviceIdRouteWithChildren =
  AuthenticatedAppCalibrationDevicesDeviceIdRoute._addFileChildren(
    AuthenticatedAppCalibrationDevicesDeviceIdRouteChildren,
  )

interface AuthenticatedAppCalibrationDevicesRouteRouteChildren {
  AuthenticatedAppCalibrationDevicesDeviceIdRoute: typeof AuthenticatedAppCalibrationDevicesDeviceIdRouteWithChildren
  AuthenticatedAppCalibrationDevicesIndexRoute: typeof AuthenticatedAppCalibrationDevicesIndexRoute
}

const AuthenticatedAppCalibrationDevicesRouteRouteChildren: AuthenticatedAppCalibrationDevicesRouteRouteChildren =
  {
    AuthenticatedAppCalibrationDevicesDeviceIdRoute:
      AuthenticatedAppCalibrationDevicesDeviceIdRouteWithChildren,
    AuthenticatedAppCalibrationDevicesIndexRoute:
      AuthenticatedAppCalibrationDevicesIndexRoute,
  }

const AuthenticatedAppCalibrationDevicesRouteRouteWithChildren =
  AuthenticatedAppCalibrationDevicesRouteRoute._addFileChildren(
    AuthenticatedAppCalibrationDevicesRouteRouteChildren,
  )

interface AuthenticatedAppCalibrationRouteRouteChildren {
  AuthenticatedAppCalibrationDevicesRouteRoute: typeof AuthenticatedAppCalibrationDevicesRouteRouteWithChildren
  AuthenticatedAppCalibrationWorkstationsRoute: typeof AuthenticatedAppCalibrationWorkstationsRoute
}

const AuthenticatedAppCalibrationRouteRouteChildren: AuthenticatedAppCalibrationRouteRouteChildren =
  {
    AuthenticatedAppCalibrationDevicesRouteRoute:
      AuthenticatedAppCalibrationDevicesRouteRouteWithChildren,
    AuthenticatedAppCalibrationWorkstationsRoute:
      AuthenticatedAppCalibrationWorkstationsRoute,
  }

const AuthenticatedAppCalibrationRouteRouteWithChildren =
  AuthenticatedAppCalibrationRouteRoute._addFileChildren(
    AuthenticatedAppCalibrationRouteRouteChildren,
  )

interface AuthenticatedAppDeliveryRouteRouteChildren {
  AuthenticatedAppDeliveryDeliveryIdRoute: typeof AuthenticatedAppDeliveryDeliveryIdRoute
  AuthenticatedAppDeliveryIndexRoute: typeof AuthenticatedAppDeliveryIndexRoute
}

const AuthenticatedAppDeliveryRouteRouteChildren: AuthenticatedAppDeliveryRouteRouteChildren =
  {
    AuthenticatedAppDeliveryDeliveryIdRoute:
      AuthenticatedAppDeliveryDeliveryIdRoute,
    AuthenticatedAppDeliveryIndexRoute: AuthenticatedAppDeliveryIndexRoute,
  }

const AuthenticatedAppDeliveryRouteRouteWithChildren =
  AuthenticatedAppDeliveryRouteRoute._addFileChildren(
    AuthenticatedAppDeliveryRouteRouteChildren,
  )

interface AuthenticatedAppDevicesRouteRouteChildren {
  AuthenticatedAppDevicesInTransitRoute: typeof AuthenticatedAppDevicesInTransitRoute
  AuthenticatedAppDevicesInactiveRoute: typeof AuthenticatedAppDevicesInactiveRoute
  AuthenticatedAppDevicesListRoute: typeof AuthenticatedAppDevicesListRoute
  AuthenticatedAppDevicesTypesIndexRoute: typeof AuthenticatedAppDevicesTypesIndexRoute
}

const AuthenticatedAppDevicesRouteRouteChildren: AuthenticatedAppDevicesRouteRouteChildren =
  {
    AuthenticatedAppDevicesInTransitRoute:
      AuthenticatedAppDevicesInTransitRoute,
    AuthenticatedAppDevicesInactiveRoute: AuthenticatedAppDevicesInactiveRoute,
    AuthenticatedAppDevicesListRoute: AuthenticatedAppDevicesListRoute,
    AuthenticatedAppDevicesTypesIndexRoute:
      AuthenticatedAppDevicesTypesIndexRoute,
  }

const AuthenticatedAppDevicesRouteRouteWithChildren =
  AuthenticatedAppDevicesRouteRoute._addFileChildren(
    AuthenticatedAppDevicesRouteRouteChildren,
  )

interface AuthenticatedAppFieldRouteRouteChildren {
  AuthenticatedAppFieldHistoryRoute: typeof AuthenticatedAppFieldHistoryRoute
  AuthenticatedAppFieldTodayRoute: typeof AuthenticatedAppFieldTodayRoute
  AuthenticatedAppFieldIndexRoute: typeof AuthenticatedAppFieldIndexRoute
}

const AuthenticatedAppFieldRouteRouteChildren: AuthenticatedAppFieldRouteRouteChildren =
  {
    AuthenticatedAppFieldHistoryRoute: AuthenticatedAppFieldHistoryRoute,
    AuthenticatedAppFieldTodayRoute: AuthenticatedAppFieldTodayRoute,
    AuthenticatedAppFieldIndexRoute: AuthenticatedAppFieldIndexRoute,
  }

const AuthenticatedAppFieldRouteRouteWithChildren =
  AuthenticatedAppFieldRouteRoute._addFileChildren(
    AuthenticatedAppFieldRouteRouteChildren,
  )

interface AuthenticatedAppMetadataRouteRouteChildren {
  AuthenticatedAppMetadataCollectionRoute: typeof AuthenticatedAppMetadataCollectionRoute
}

const AuthenticatedAppMetadataRouteRouteChildren: AuthenticatedAppMetadataRouteRouteChildren =
  {
    AuthenticatedAppMetadataCollectionRoute:
      AuthenticatedAppMetadataCollectionRoute,
  }

const AuthenticatedAppMetadataRouteRouteWithChildren =
  AuthenticatedAppMetadataRouteRoute._addFileChildren(
    AuthenticatedAppMetadataRouteRouteChildren,
  )

interface AuthenticatedAppProfileRouteRouteChildren {
  AuthenticatedAppProfileAccountRoute: typeof AuthenticatedAppProfileAccountRoute
}

const AuthenticatedAppProfileRouteRouteChildren: AuthenticatedAppProfileRouteRouteChildren =
  {
    AuthenticatedAppProfileAccountRoute: AuthenticatedAppProfileAccountRoute,
  }

const AuthenticatedAppProfileRouteRouteWithChildren =
  AuthenticatedAppProfileRouteRoute._addFileChildren(
    AuthenticatedAppProfileRouteRouteChildren,
  )

interface AuthenticatedAppRawFootageRouteRouteChildren {
  AuthenticatedAppRawFootageIndexRoute: typeof AuthenticatedAppRawFootageIndexRoute
  AuthenticatedAppRawFootageUploadsSessionIdRoute: typeof AuthenticatedAppRawFootageUploadsSessionIdRoute
  AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRoute: typeof AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRoute
  AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRoute: typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRoute
  AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRoute: typeof AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRoute
}

const AuthenticatedAppRawFootageRouteRouteChildren: AuthenticatedAppRawFootageRouteRouteChildren =
  {
    AuthenticatedAppRawFootageIndexRoute: AuthenticatedAppRawFootageIndexRoute,
    AuthenticatedAppRawFootageUploadsSessionIdRoute:
      AuthenticatedAppRawFootageUploadsSessionIdRoute,
    AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRoute:
      AuthenticatedAppRawFootageMcapSegmentsAssetIdSegmentIdRoute,
    AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRoute:
      AuthenticatedAppRawFootageOrganizationsOrganizationIdIndexRoute,
    AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRoute:
      AuthenticatedAppRawFootageOrganizationsOrganizationIdProjectsProjectIdRoute,
  }

const AuthenticatedAppRawFootageRouteRouteWithChildren =
  AuthenticatedAppRawFootageRouteRoute._addFileChildren(
    AuthenticatedAppRawFootageRouteRouteChildren,
  )

interface AuthenticatedAppSupervisorTaskAssignmentRouteRouteChildren {
  AuthenticatedAppSupervisorTaskAssignmentRequestIdRoute: typeof AuthenticatedAppSupervisorTaskAssignmentRequestIdRoute
  AuthenticatedAppSupervisorTaskAssignmentNewRoute: typeof AuthenticatedAppSupervisorTaskAssignmentNewRoute
  AuthenticatedAppSupervisorTaskAssignmentIndexRoute: typeof AuthenticatedAppSupervisorTaskAssignmentIndexRoute
}

const AuthenticatedAppSupervisorTaskAssignmentRouteRouteChildren: AuthenticatedAppSupervisorTaskAssignmentRouteRouteChildren =
  {
    AuthenticatedAppSupervisorTaskAssignmentRequestIdRoute:
      AuthenticatedAppSupervisorTaskAssignmentRequestIdRoute,
    AuthenticatedAppSupervisorTaskAssignmentNewRoute:
      AuthenticatedAppSupervisorTaskAssignmentNewRoute,
    AuthenticatedAppSupervisorTaskAssignmentIndexRoute:
      AuthenticatedAppSupervisorTaskAssignmentIndexRoute,
  }

const AuthenticatedAppSupervisorTaskAssignmentRouteRouteWithChildren =
  AuthenticatedAppSupervisorTaskAssignmentRouteRoute._addFileChildren(
    AuthenticatedAppSupervisorTaskAssignmentRouteRouteChildren,
  )

interface AuthenticatedAppSupervisorTeamRouteRouteChildren {
  AuthenticatedAppSupervisorTeamCamerasRoute: typeof AuthenticatedAppSupervisorTeamCamerasRoute
  AuthenticatedAppSupervisorTeamFieldActivityRoute: typeof AuthenticatedAppSupervisorTeamFieldActivityRoute
  AuthenticatedAppSupervisorTeamIndexRoute: typeof AuthenticatedAppSupervisorTeamIndexRoute
}

const AuthenticatedAppSupervisorTeamRouteRouteChildren: AuthenticatedAppSupervisorTeamRouteRouteChildren =
  {
    AuthenticatedAppSupervisorTeamCamerasRoute:
      AuthenticatedAppSupervisorTeamCamerasRoute,
    AuthenticatedAppSupervisorTeamFieldActivityRoute:
      AuthenticatedAppSupervisorTeamFieldActivityRoute,
    AuthenticatedAppSupervisorTeamIndexRoute:
      AuthenticatedAppSupervisorTeamIndexRoute,
  }

const AuthenticatedAppSupervisorTeamRouteRouteWithChildren =
  AuthenticatedAppSupervisorTeamRouteRoute._addFileChildren(
    AuthenticatedAppSupervisorTeamRouteRouteChildren,
  )

interface AuthenticatedAppSupervisorRouteRouteChildren {
  AuthenticatedAppSupervisorTaskAssignmentRouteRoute: typeof AuthenticatedAppSupervisorTaskAssignmentRouteRouteWithChildren
  AuthenticatedAppSupervisorTeamRouteRoute: typeof AuthenticatedAppSupervisorTeamRouteRouteWithChildren
  AuthenticatedAppSupervisorAssetsRoute: typeof AuthenticatedAppSupervisorAssetsRoute
  AuthenticatedAppSupervisorSegmentsRoute: typeof AuthenticatedAppSupervisorSegmentsRoute
  AuthenticatedAppSupervisorIndexRoute: typeof AuthenticatedAppSupervisorIndexRoute
}

const AuthenticatedAppSupervisorRouteRouteChildren: AuthenticatedAppSupervisorRouteRouteChildren =
  {
    AuthenticatedAppSupervisorTaskAssignmentRouteRoute:
      AuthenticatedAppSupervisorTaskAssignmentRouteRouteWithChildren,
    AuthenticatedAppSupervisorTeamRouteRoute:
      AuthenticatedAppSupervisorTeamRouteRouteWithChildren,
    AuthenticatedAppSupervisorAssetsRoute:
      AuthenticatedAppSupervisorAssetsRoute,
    AuthenticatedAppSupervisorSegmentsRoute:
      AuthenticatedAppSupervisorSegmentsRoute,
    AuthenticatedAppSupervisorIndexRoute: AuthenticatedAppSupervisorIndexRoute,
  }

const AuthenticatedAppSupervisorRouteRouteWithChildren =
  AuthenticatedAppSupervisorRouteRoute._addFileChildren(
    AuthenticatedAppSupervisorRouteRouteChildren,
  )

interface AuthenticatedAppUserManagementRoleRouteRouteChildren {
  AuthenticatedAppUserManagementRolePermissionSetIdRoute: typeof AuthenticatedAppUserManagementRolePermissionSetIdRoute
  AuthenticatedAppUserManagementRoleIndexRoute: typeof AuthenticatedAppUserManagementRoleIndexRoute
}

const AuthenticatedAppUserManagementRoleRouteRouteChildren: AuthenticatedAppUserManagementRoleRouteRouteChildren =
  {
    AuthenticatedAppUserManagementRolePermissionSetIdRoute:
      AuthenticatedAppUserManagementRolePermissionSetIdRoute,
    AuthenticatedAppUserManagementRoleIndexRoute:
      AuthenticatedAppUserManagementRoleIndexRoute,
  }

const AuthenticatedAppUserManagementRoleRouteRouteWithChildren =
  AuthenticatedAppUserManagementRoleRouteRoute._addFileChildren(
    AuthenticatedAppUserManagementRoleRouteRouteChildren,
  )

interface AuthenticatedAppUserManagementRouteRouteChildren {
  AuthenticatedAppUserManagementRoleRouteRoute: typeof AuthenticatedAppUserManagementRoleRouteRouteWithChildren
  AuthenticatedAppUserManagementAccountRoute: typeof AuthenticatedAppUserManagementAccountRoute
  AuthenticatedAppUserManagementInvitationsRoute: typeof AuthenticatedAppUserManagementInvitationsRoute
}

const AuthenticatedAppUserManagementRouteRouteChildren: AuthenticatedAppUserManagementRouteRouteChildren =
  {
    AuthenticatedAppUserManagementRoleRouteRoute:
      AuthenticatedAppUserManagementRoleRouteRouteWithChildren,
    AuthenticatedAppUserManagementAccountRoute:
      AuthenticatedAppUserManagementAccountRoute,
    AuthenticatedAppUserManagementInvitationsRoute:
      AuthenticatedAppUserManagementInvitationsRoute,
  }

const AuthenticatedAppUserManagementRouteRouteWithChildren =
  AuthenticatedAppUserManagementRouteRoute._addFileChildren(
    AuthenticatedAppUserManagementRouteRouteChildren,
  )

interface AuthenticatedAppRouteChildren {
  AuthenticatedAppCalibrationRouteRoute: typeof AuthenticatedAppCalibrationRouteRouteWithChildren
  AuthenticatedAppDeliveryRouteRoute: typeof AuthenticatedAppDeliveryRouteRouteWithChildren
  AuthenticatedAppDevicesRouteRoute: typeof AuthenticatedAppDevicesRouteRouteWithChildren
  AuthenticatedAppFieldRouteRoute: typeof AuthenticatedAppFieldRouteRouteWithChildren
  AuthenticatedAppMetadataRouteRoute: typeof AuthenticatedAppMetadataRouteRouteWithChildren
  AuthenticatedAppProfileRouteRoute: typeof AuthenticatedAppProfileRouteRouteWithChildren
  AuthenticatedAppRawFootageRouteRoute: typeof AuthenticatedAppRawFootageRouteRouteWithChildren
  AuthenticatedAppSupervisorRouteRoute: typeof AuthenticatedAppSupervisorRouteRouteWithChildren
  AuthenticatedAppUserManagementRouteRoute: typeof AuthenticatedAppUserManagementRouteRouteWithChildren
  AuthenticatedAppTransfersRoute: typeof AuthenticatedAppTransfersRoute
  AuthenticatedAppIndexRoute: typeof AuthenticatedAppIndexRoute
  AuthenticatedAppAdminOrganizationsRoute: typeof AuthenticatedAppAdminOrganizationsRoute
  AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRoute: typeof AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRoute
}

const AuthenticatedAppRouteChildren: AuthenticatedAppRouteChildren = {
  AuthenticatedAppCalibrationRouteRoute:
    AuthenticatedAppCalibrationRouteRouteWithChildren,
  AuthenticatedAppDeliveryRouteRoute:
    AuthenticatedAppDeliveryRouteRouteWithChildren,
  AuthenticatedAppDevicesRouteRoute:
    AuthenticatedAppDevicesRouteRouteWithChildren,
  AuthenticatedAppFieldRouteRoute: AuthenticatedAppFieldRouteRouteWithChildren,
  AuthenticatedAppMetadataRouteRoute:
    AuthenticatedAppMetadataRouteRouteWithChildren,
  AuthenticatedAppProfileRouteRoute:
    AuthenticatedAppProfileRouteRouteWithChildren,
  AuthenticatedAppRawFootageRouteRoute:
    AuthenticatedAppRawFootageRouteRouteWithChildren,
  AuthenticatedAppSupervisorRouteRoute:
    AuthenticatedAppSupervisorRouteRouteWithChildren,
  AuthenticatedAppUserManagementRouteRoute:
    AuthenticatedAppUserManagementRouteRouteWithChildren,
  AuthenticatedAppTransfersRoute: AuthenticatedAppTransfersRoute,
  AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute,
  AuthenticatedAppAdminOrganizationsRoute:
    AuthenticatedAppAdminOrganizationsRoute,
  AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRoute:
    AuthenticatedAppRelocationsOrganizationIdProjectIdFootageKeyRoute,
}

const AuthenticatedAppRouteWithChildren =
  AuthenticatedAppRoute._addFileChildren(AuthenticatedAppRouteChildren)

interface AuthenticatedWorkspaceRouteChildren {
  AuthenticatedWorkspaceAssetsAssetIdRoute: typeof AuthenticatedWorkspaceAssetsAssetIdRoute
  AuthenticatedWorkspaceDevicesDeviceIdRoute: typeof AuthenticatedWorkspaceDevicesDeviceIdRoute
  AuthenticatedWorkspaceFieldVisitsVisitIdRoute: typeof AuthenticatedWorkspaceFieldVisitsVisitIdRoute
  AuthenticatedWorkspaceUserManagementAccountUidRoute: typeof AuthenticatedWorkspaceUserManagementAccountUidRoute
  AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRoute: typeof AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRoute
}

const AuthenticatedWorkspaceRouteChildren: AuthenticatedWorkspaceRouteChildren =
  {
    AuthenticatedWorkspaceAssetsAssetIdRoute:
      AuthenticatedWorkspaceAssetsAssetIdRoute,
    AuthenticatedWorkspaceDevicesDeviceIdRoute:
      AuthenticatedWorkspaceDevicesDeviceIdRoute,
    AuthenticatedWorkspaceFieldVisitsVisitIdRoute:
      AuthenticatedWorkspaceFieldVisitsVisitIdRoute,
    AuthenticatedWorkspaceUserManagementAccountUidRoute:
      AuthenticatedWorkspaceUserManagementAccountUidRoute,
    AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRoute:
      AuthenticatedWorkspaceCalibrationDevicesDeviceIdSessionsSessionIdRoute,
  }

const AuthenticatedWorkspaceRouteWithChildren =
  AuthenticatedWorkspaceRoute._addFileChildren(
    AuthenticatedWorkspaceRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAppRoute: typeof AuthenticatedAppRouteWithChildren
  AuthenticatedWorkspaceRoute: typeof AuthenticatedWorkspaceRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAppRoute: AuthenticatedAppRouteWithChildren,
  AuthenticatedWorkspaceRoute: AuthenticatedWorkspaceRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
